@if (compact) {
  <label [for]="controlId" class="forge-typography--label1 compact-mode--label"
    [ngClass]="{'compact-mode--label-required': isRequired, 'compact-mode--label-invalid': error.length > 0}">{{Label}}
</label>
}
<forge-text-field [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [required]="isRequired"
    [invalid]="isInvalid" [attr.shape]="forCellEdit ? 'squared' : null">
  <textarea #input [disabled]="isViewOnly" [id]="controlId" [(ngModel)]="valueModel" (input)="onInputChange()"
        (change)="onChange()" [required]="isRequired" [minlength]="propertyMetadata.MinLength!"
        (keydown)="enforceFormat($event, true)" [maxlength]="propertyMetadata.MaxLength!" [rows]="Rows()" focusOnLoad
        [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit" attr.telemetry="Edit-{{Label}}" [name]="Name"
        (keyup)="updateCurrentLength($event)" autocomplete="off">
  </textarea>
    @if (showLabel) {
    <label [for]="controlId">{{Label}}</label>
    }
    @if (showCounter) {
    <span slot="support-text" style="float: right;">{{currentLength || 0}}/{{MaxLength}}</span>
    }
    @if (showHint) {
    <span slot="support-text" [hidden]="!hint">{{hint}}</span>
    }
    @if (showError) {
    <span slot="support-text" class="error-red">{{error}}</span>
    }
</forge-text-field>